<template>
  <FormSelect
    label="Area"
    :values="values"
    :options="options"
    :rules="[VALIDATION.requiredArray]"
    :loading="loading"
    :disable="loading || disabled"
    :multiple="multiple"
    :region="region"
    @updateStore="onUpdateStore"
  />
</template>

<script>
import { ref, watch, onBeforeMount } from 'vue'
import { FormSelect } from '@/components/inputs'
import { VALIDATION, Toast, fetchData } from '@/tools'

export default {
  name: 'SelectAreas',
  inheritAttrs: true,
  emits: ['updateStore'],
  components: {
    FormSelect
  },
  props: {
    values: {
      type: [String, Number, Array],
      default: null
    },
    multiple: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: true
    },
    region: {
      type: String,
      default: null
    }
  },
  setup(props, { emit }) {
    const { data, error, loading, get } = fetchData()
    const { showToast } = Toast()
    const options = ref([])

    const onUpdateStore = data => {
      emit('updateStore', data)
    }

    const getAreas = () => {
      get(`v1/user/area-access/?region_id=${props.region}`)
    }

    watch(
      () => props.region,
      () => {
        getAreas()
      }
    )

    onBeforeMount(() => {
      watch([data, error, loading], () => {
        if (!loading.value) {
          if (error?.value) {
            showToast('There was a problem fetching stores.', 'danger')
          } else if (data?.value) {
            options.value = data?.value?.map(item => ({
              label: item?.area_name,
              value: item?.area_id
            }))
          }
        }
      })
    })

    return { options, loading, VALIDATION, onUpdateStore }
  }
}
</script>
